export const SUCCESS_MESSAGES = {
  procedureAdded: "Procedimento adicionado",
  kitCreated: "Pacote criado",
  summaryDownloaded: "Resumo baixado",
  appealSaved: "Recurso salvo no pedido",
  emailSent: "E-mail enviado",
  whatsAppOpened: "WhatsApp aberto com a mensagem pronta",
  secretaryAdded: "Secretária(s) adicionada(s) com sucesso!",
  secretaryRemoved: "Secretária removida com sucesso!",
  emailAccountConnected: "Conta de email conectada com sucesso!",
  emailAccountDisconnected: "Conta de email desconectada com sucesso.",
  companyLinked: "Empresa vinculada com sucesso!",
  companyUnlinked: "Empresa desvinculada com sucesso!",
  hospitalLinked: "Hospital vinculado com sucesso!",
  hospitalUnlinked: "Hospital desvinculado com sucesso!",
  reservaLinked: "Reserva vinculada com sucesso!",
  reservaUnlinked: "Reserva desvinculada com sucesso!",
  onboardingSaved: "Dados salvos com sucesso!",
  documentRead: "Dados do documento preenchidos. Confira antes de salvar.",
  orderDataSaved: "Dados do pedido salvos",
} as const;

export type SuccessKey = keyof typeof SUCCESS_MESSAGES;
